import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function SearchBar({ className = "" }) {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSearch = () => {
        if (searchTerm.trim()) {
            navigate(`/browse?search=${encodeURIComponent(searchTerm)}`);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className={`search-bar-container flex items-center space-x-2 w-full max-w-[1000px] ${className}`}>
            <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyPress={handleKeyPress}
                className="search-bar w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#9b4819] font-serif"
                placeholder="Search proteins..."
            />
            <button 
                onClick={handleSearch} 
                className="search-button px-4 py-2 bg-[#9b4819] text-white rounded-lg hover:bg-[#7b3813] focus:outline-none focus:ring-2 focus:ring-[#9b4819]"
            >
                <FontAwesomeIcon icon={faSearch} className="text-lg" />
            </button>
        </div>
    );
}

export default SearchBar;